var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    {
      staticClass: "col content-spacing",
      staticStyle: { "max-width": "88% !important" },
      attrs: { role: "main" }
    },
    [
      _c(
        "section",
        [
          _c(
            "PageHeader",
            {
              staticStyle: { "padding-top": "1rem" },
              attrs: { pageTitle: "Relatório de Leads" }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", gap: "0.5rem" } },
                [
                  _c("QualifiedLeadsPrimaryCnaeSelect", {
                    model: {
                      value: _vm.cnaeList,
                      callback: function($$v) {
                        _vm.cnaeList = $$v
                      },
                      expression: "cnaeList"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { display: "flex", gap: "0.5rem" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Data inicial" } },
                    [
                      _c("b-form-datepicker", {
                        attrs: {
                          locale: "pt-BR",
                          "aria-label": "Escolha a data inicial",
                          title: "Selecione a data inicial",
                          "label-no-date-selected": "Nenhuma data selecionada"
                        },
                        model: {
                          value: _vm.startDate,
                          callback: function($$v) {
                            _vm.startDate = $$v
                          },
                          expression: "startDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { attrs: { label: "Data final" } },
                    [
                      _c("b-form-datepicker", {
                        attrs: {
                          locale: "pt-BR",
                          "aria-label": "Escolha a data final",
                          min: _vm.startDate,
                          title: "Selecione a data final",
                          "label-no-date-selected": "Nenhuma data selecionada"
                        },
                        model: {
                          value: _vm.endDate,
                          callback: function($$v) {
                            _vm.endDate = $$v
                          },
                          expression: "endDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "BaseButtonComponent",
                {
                  staticStyle: { padding: "1px 12px" },
                  attrs: { variant: "primary-action" },
                  on: { click: _vm.getLeads }
                },
                [_vm._v("\n        Buscar\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c("b-skeleton-table", {
            staticStyle: { "margin-top": "2rem" },
            attrs: {
              animation: "wave",
              rows: 5,
              columns: 12,
              "table-props": { bordered: true, striped: true }
            }
          })
        : _c("LeadsReportTable", {
            attrs: { list: _vm.leads, isLoading: _vm.isLoading }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }